import { useLayoutEffect, useRef, useState } from "react";

import { MenuItem } from "../MenuItem";
import { useLocation } from "react-router-dom";

const MenuList = ({ type = "", className = "", list = [], activeTab, showDropdown = false, onMenuItemClick }) => {
    const listRef = useRef();
    const [height, setHeight] = useState(0);
    const location = useLocation();

    useLayoutEffect(() => {
        if (listRef.current) {
            let listHeight = listRef.current?.offsetHeight;
            setHeight(listHeight);
        }
    }, []);

    return (
        <div className={className} style={{ maxHeight: type === "dropdown" ? (showDropdown ? height + 32 : 0) : "auto" }}>
            <ul ref={listRef}>
                {list?.length > 0 &&
                    list?.map((menuItem) => {
                        const href = menuItem?.href || "";

                        const isActive =
                            (href.startsWith("/calendar-featured") && location.pathname.startsWith("/calendar-featured")) ||
                            (href.startsWith("/calendar") && location.pathname.startsWith("/calendar")) ||
                            location.pathname.startsWith(href) ||
                            activeTab === href;
                        return (
                            <MenuItem
                                key={menuItem?.label}
                                {...menuItem}
                                isActive={isActive}
                                onChangeActivetab={onMenuItemClick}
                                height={height}
                                type={type}
                                activeTab={activeTab}
                            />
                        );
                    })}
            </ul>
        </div>
    );
};

export default MenuList;
